import React, { Fragment, PureComponent } from "react";
import { Route, withRouter } from "react-router-dom";
import Index from "./pages/Index";
import PageLoading from "components/PageLoading";
import LoadableVisibility from "react-loadable-visibility/react-loadable";
import PrivateRoute from '@/components/Routes/PrivateRoute';
import "./App.css";
const Login = LoadableVisibility({
    loader: () => import("./pages/Login"),
    loading: () => <PageLoading />
});
const LoginComponent = function(props) {
    const { staticContext, ...otherProps } = props
    return  <Login { ...otherProps } />
}

const Register = LoadableVisibility({
    loader: () => import("./pages/Register"),
    loading: () => <PageLoading />
});
const RegisterComponent = function(props) {
    const { staticContext, ...otherProps } = props
    return  <Register { ...otherProps } />
}

const Peizi = LoadableVisibility({
    loader: () => import("./pages/Peizi"),
    loading: () => <PageLoading />
});
const Agreement = LoadableVisibility({
    loader: () => import("./pages/Agreement"),
    loading: () => <PageLoading />
});
const Trial = LoadableVisibility({
    loader: () => import("./pages/Peizi/Trial"),
    loading: () => <PageLoading />
});
const Member = LoadableVisibility({
    loader: () => import("./pages/Member"),
    loading: () => <PageLoading />
});
const Trade = LoadableVisibility({
    loader: () => import("./pages/Trade"),
    loading: () => <PageLoading />
});

const TradeComponent = function(props) {
    const { staticContext, ...otherProps } = props
    return  <Trade { ...otherProps } />
}
const Download = LoadableVisibility({
    loader: () => import("./pages/Download"),
    loading: () => <PageLoading />
});
const Article = LoadableVisibility({
    loader: () => import("./pages/Article"),
    loading: () => <PageLoading />
});
const Detail = LoadableVisibility({
    loader: () => import("./pages/Article/Detail"),
    loading: () => <PageLoading />
});
const InviteReg = LoadableVisibility({
    loader: () => import("./pages/InviteReg"),
    loading: () => <PageLoading />
});

const GetPass = LoadableVisibility({
    loader: () => import("./pages/GetPass"),
    loading: () => <PageLoading />
});

const WebView = LoadableVisibility({
    loader: () => import("./pages/WebView"),
    loading: () => <PageLoading />
});

class App extends PureComponent {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }
    render() {
        return (
            <Fragment>
                <Route path="/" exact component={Index} />
                <Route path="/login" component={LoginComponent} />
                
                <Route path="/register" component={RegisterComponent} />
                <Route path="/getpass" component={GetPass} />
                <Route path="/agreement" component={Agreement} />
                <Route path="/member" component={Member} />
                <Route path="/download" component={Download} />
                <Route path="/trade" component={TradeComponent} />
                <PrivateRoute path="/peizi" component={Peizi} />
                <Route path="/news/:id" component={Article} />
                <Route path="/article/detail/:id/:model" component={Detail} />
                <Route path="/invite/:code" component={InviteReg} />
                <Route path="/trial" component={Trial} />
                <Route path="/webview" component={WebView} />
            </Fragment>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js


// WEBPACK FOOTER //
// ./src/App.js